import { Component } from '@angular/core';

import { classes } from '@optical/ui/utils';

@Component({
  selector: 'knx-page-title',
  templateUrl: './page-title.component.html',
})
export class PageTitleComponent {
  constructor() {
    classes(() => 'font-title text-foreground block text-2xl font-bold');
  }
}
